module.exports = __webpack_public_path__ + "static/img/bg68.a342b1d6.png";